import { cn } from 'components/UI/cn'
import { secondaryPillButtonClass } from 'components/FbUI/secondaryPillButton'

interface ActionButtonProps {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export function ActionButton({
  children,
  onClick,
  disabled = false,
  className = '',
}: ActionButtonProps) {
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={cn(
        secondaryPillButtonClass,
        disabled &&
          'opacity-50 cursor-not-allowed hover:bg-white hover:shadow-none hover:border-neutral-300 hover:text-neutral-800',
        className
      )}
    >
      {children}
    </button>
  )
}
